import React from "react";

export default function Book(props) {
  return (
    <svg
      width="89px"
      height="121px"
      viewBox="0 0 89 121"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Slice</title>
      <desc>Created with Sketch.</desc>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="0.504301525"
      >
        <g id="book" transform="translate(-0.162470, 0.601454)" fill="#FFFFFF">
          <path
            d="M50.054306,70.6617186 C49.5205308,70.6617186 48.99612,70.51875 48.5349196,70.2480468 L38.1731245,64.1472657 L27.8113295,70.2480468 C26.8854167,70.7929686 25.7382681,70.8 24.805332,70.265625 C23.8723957,69.73125 23.2964806,68.7375 23.2964806,67.6617186 L23.2964806,22.7765625 L29.2897466,22.7765625 L29.2897466,62.4175782 L36.6549083,58.0816407 C37.5925269,57.5296875 38.7548927,57.5296875 39.692511,58.0816407 L47.057673,62.4175782 L47.057673,22.7765625 L53.050939,22.7765625 L53.050939,67.6617186 C53.050939,69.31875 51.7094777,70.6617186 50.054306,70.6617186 Z"
            id="Path"
          ></path>
          <path
            d="M85.7950075,120 L13.0751524,120 C5.86567505,120 0,114.246094 0,107.172656 L0,12.8273436 C0.00819393333,5.746875 5.87035729,0 13.0751524,0 L73.5076414,0 C75.1616423,0 76.5042744,1.3429686 76.5042744,3 L76.5042744,19.6675782 L85.7950075,19.6675782 C87.4501789,19.6675782 88.7916405,21.0105468 88.7916405,22.6675782 L88.7916405,117 C88.7916405,118.657031 87.4501789,120 85.7950075,120 Z M5.99326599,23.6191407 L5.99326599,107.172656 C5.99326599,110.937891 9.17016504,114 13.0751524,114 L82.7983745,114 L82.7983745,25.6675782 L13.0751524,25.6675782 C10.5678136,25.6722657 8.11080853,24.9621093 5.99326599,23.6191407 Z M13.0751524,6 C9.17016504,6 5.99326599,9.0621093 5.99326599,12.8273436 C5.99326599,16.6066407 9.17016504,19.6664064 13.0751524,19.6664064 L70.5110084,19.6664064 L70.5110084,6 L13.0751524,6 Z"
            id="book-Shape"
            fillRule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
  );
}
